<template>
  <v-container id="reset-password-reset">
    <v-row justify="center">
      <v-col lg="6">
        <MaterialCard
          :title="this.$t('title.reset_password')"
          color="primary"
          elevation="0"
        >
          <v-form
            v-model="formValid"
            ref="reset_password_form"
            spellcheck="false"
          >
            <v-row class="ma-0">
              <v-col>
                <v-text-field
                  v-model="password"
                  color="primary"
                  type="password"
                  validate-on-blur
                  required
                  :rules="rules.password"
                  :label="$t('label.password')"
                />
                <v-text-field
                  v-model="password_repeated"
                  color="primary"
                  type="password"
                  validate-on-blur
                  required
                  :rules="rules.repeated"
                  :label="$t('label.repeated_password')"
                />
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="primary"
                  class="no-text-transform display-1"
                  type="submit"
                  :disabled="!formValid"
                  :loading="loading"
                  @click="resetPassword"
                  >{{ this.$t("button.send") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </MaterialCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCard from "@/components/views/MaterialCard";

export default {
  name: "Reset",
  components: { MaterialCard },
  data() {
    return {
      formValid: false,
      loading: false,
      reset_token: null,
      password: "",
      password_repeated: "",
      rules: {
        repeated: [
          v =>
            (!!v && v === this.password) ||
            this.$t("rules.password_should_be_equal"),
          v =>
            (v.length > 7 && /(?=.*[^a-zA-Z])(?=.*[a-zA-Z]).{8,}/.test(v)) ||
            this.$t("rules.password_validation")
        ],
        password: [
          v => !!v || this.$t("rules.password_required"),
          v =>
            (v.length > 7 && /(?=.*[^a-zA-Z])(?=.*[a-zA-Z]).{8,}/.test(v)) ||
            this.$t("rules.password_validation")
        ]
      }
    };
  },
  beforeCreate() {
    this.reset_token = this.$route.params.token;
    this.$store
      .dispatch("user/validateResetPasswordToken", this.reset_token)
      .catch(() => {
        this.$store.commit("viewstate/notify", {
          color: "error",
          text: this.$t("error.user_not_found_by_reset_token")
        });
        this.$router.push("/");
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    resetPassword(e) {
      e.preventDefault();
      if (!this.$refs.reset_password_form.validate()) {
        return;
      }

      this.loading = true;
      this.$store
        .dispatch("user/resetPassword", {
          password: this.password,
          reset_token: this.$route.params.token
        })
        .then(() => {
          this.$store.commit("viewstate/notify", {
            color: "success",
            text: this.$t("success.changed_password")
          });
          this.$router.push("/");
        })
        .catch(() => {
          this.$store.commit("viewstate/notify", {
            color: "error",
            text: this.$t("error.changed_password")
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped></style>
